import Vue from 'vue'
import VueRouter from 'vue-router'
import Home  from "@/views/Home.vue";
import Oxylvl from "@/views/Oxylvl.vue";
import Knowledge from "@/views/Knowledge.vue";
import Doctor from "@/views/Doctor.vue";
import Emergency from "@/views/Emergency"; 
import Doctorph from "@/views/Doctorph";
import Medical from "@/views/Medical" ;

Vue.use(VueRouter);

const routes =  [
        {path:'/', component: Home} ,
        { path:'/oxylvl', component: Oxylvl},
        { path:'/knowledge', component: Knowledge},
        {path:'/doctor' , component: Doctor},
        {path: '/emergency', component: Emergency},
        {path:'/doctorph' , component: Doctorph},
        {path:'/medical' , component: Medical},
    
    ];

const router = new VueRouter ({
    mode:'history',
    routes,
});

export default router;